import enLocale from './en' //英文
import zhCNLocale from './zh-CN' //简体中文
import zhTWLocale from './zh-TW' //繁体中文
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementTWLocale from 'element-ui/lib/locale/lang/zh-TW'
const messages = {
	'en': {
		...enLocale,
		...elementEnLocale
	},
	'zh-CN': {
		...zhCNLocale,
		...elementCNLocale
	},
	'zh-TW': {
		...zhTWLocale,
		...elementTWLocale
	}
}
export default messages
